<!--<ion-header>-->
<!--  <app-order-page-toolbar-->
<!--    (backClick)="dismiss()"-->
<!--    (close)="dismiss()"-->
<!--    [hideElements]="loading"-->
<!--    [preorderType]="order?.preorder?.type"-->
<!--    title="{{ 'payment_modal.title' | translate }}"-->
<!--  ></app-order-page-toolbar>-->
<!--</ion-header>-->
<!--<ion-content>-->
<!--  <ion-row>-->
<!--    <ion-col>-->
<!--      <h1 class="ion-margin header-msg">-->
<!--        {{ 'payment_modal.message' | translate }}-->
<!--      </h1>-->
<!--    </ion-col>-->
<!--  </ion-row>-->
<!--  <ion-row>-->
<!--    <ion-col size="12">-->
<!--      <ion-radio-group-->
<!--        (ionChange)="loadPayment()"-->
<!--        [(ngModel)]="selectedPaymentMethod"-->
<!--        [disabled]="loading"-->
<!--        >-->
<!--        @for (method of paymentMethods; track method) {-->
<!--          <ion-item-->
<!--            [disabled]="loading"-->
<!--            class="payment-method-row"-->
<!--            lines="none"-->
<!--            >-->
<!--            <ion-label>{{ method | translate }}</ion-label>-->
<!--            <ion-radio [value]="method" slot="start"></ion-radio>-->
<!--            <ion-icon-->
<!--              class="icon-size"-->
<!--              size="large"-->
<!--              slot="end"-->
<!--              src="/assets/icon/{{ method }}.svg"-->
<!--            ></ion-icon>-->
<!--          </ion-item>-->
<!--        }-->
<!--      </ion-radio-group>-->
<!--      @if (selectedPaymentMethod) {-->
<!--        <div-->
<!--          [class.ion-hide]="loading"-->
<!--          class="payment-input"-->
<!--          >-->
<!--          @if (-->
<!--            selectedPaymentMethod == pm.CREDIT_CARD &&-->
<!--            venue &&-->
<!--            venue.vrPaymentEnabled-->
<!--            ) {-->
<!--            <form-->
<!--              [action]="vrUrl"-->
<!--              class="paymentWidgets"-->
<!--              data-brands="MASTER VISA"-->
<!--            ></form>-->
<!--          }-->
<!--          @if (-->
<!--            selectedPaymentMethod == pm.CREDIT_CARD &&-->
<!--            !venue.vrPaymentEnabled &&-->
<!--            venue.ppFullIntegrationEnabled-->
<!--            ) {-->
<!--            <div-->
<!--              id="paypal-cc-button"-->
<!--            ></div>-->
<!--          }-->
<!--          @if (selectedPaymentMethod == pm.GPAY) {-->
<!--            <form-->
<!--              [action]="vrUrl"-->
<!--              class="paymentWidgets"-->
<!--              data-brands="GOOGLEPAY"-->
<!--            ></form>-->
<!--          }-->
<!--          @if (selectedPaymentMethod == pm.APAY) {-->
<!--            <form-->
<!--              [action]="vrUrl"-->
<!--              class="paymentWidgets"-->
<!--              data-brands="APPLEPAY"-->
<!--            ></form>-->
<!--          }-->
<!--          @if (selectedPaymentMethod == pm.PAYPAL) {-->
<!--            <div-->
<!--              id="paypal-button"-->
<!--            ></div>-->
<!--          }-->
<!--          @if (selectedPaymentMethod == pm.SOFORTBANKING) {-->
<!--            <div-->
<!--              id="klarna-button"-->
<!--            ></div>-->
<!--          }-->
<!--        </div>-->
<!--      }-->
<!--    </ion-col>-->
<!--  </ion-row>-->
<!--  <ion-row class="ion-padding ion-justify-content-center">-->
<!--    <ion-spinner [class.ion-hide]="!loading"></ion-spinner>-->
<!--  </ion-row>-->
<!--</ion-content>-->
